import { gql } from "@apollo/client";

export const SEARCH_SUGGESTIONS_FIELDS_FRAGMENT = gql`
  fragment SearchSuggestionsFieldsFragment on SearchSuggestionsOutput {
    fields {
      name
      orderable
      filterable
      type
      possibleValuesBoolean {
        values
        counts
      }
      possibleValuesEnum {
        values
        counts
      }
      possibleValuesString {
        values
        counts
      }
      possibleValuesHierarchy {
        values {
          id
          parentId
          displayValue
        }
        counts
        directCounts
      }
    }
  }
`;

export const SEARCH_SUGGESTIONS_FRAGMENT = gql`
  fragment SearchSuggestionsFragment on SearchSuggestionsOutput {
    filteredCount
    ...SearchSuggestionsFieldsFragment
  }
  ${SEARCH_SUGGESTIONS_FIELDS_FRAGMENT}
`;
